import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import { setCasinoId, setCasinoIdStatus, setCurrentMemberLevel } from '../../../state/actions/playerInfo';
import AppInterface from '../../../api/AppInterface';
import PlayerInterface from '../../../api/PlayerInterface';
export var postRegisterNewCardMutation = {
  query: function query(data) {
    return {
      url: Endpoints.REGISTER_REWARD_CARD,
      method: 'post',
      body: {
        data: data
      }
    };
  },
  transformResponse: function transformResponse(response) {
    return response;
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
      var dispatch, queryFulfilled, _response$data, _response$data$, response;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              response = _context.sent;

              if (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$ = _response$data[0]) === null || _response$data$ === void 0 ? void 0 : _response$data$.success) {
                updateUserData(dispatch);
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              handleQueryLoggerEvents(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};

var updateUserData = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
    var initAppRes;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return AppInterface.initApp();

          case 3:
            initAppRes = _context2.sent;
            dispatch(setCasinoIdStatus(initAppRes.CASINO_ID_STATUS));
            dispatch(setCasinoId(initAppRes.CASINO_ID));
            dispatch(setCurrentMemberLevel(initAppRes.CURRENT_MEMBER_LEVEL));
            _context2.next = 9;
            return PlayerInterface.getPlayerProfile();

          case 9:
            _context2.next = 14;
            break;

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](0);
            handleQueryLoggerEvents(_context2.t0);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 11]]);
  }));

  return function updateUserData(_x3) {
    return _ref2.apply(this, arguments);
  };
}();